import PrintableText from './PrintableText';
import PrintableHtml from './PrintableHtml';
import PrintableResult from './PrintableResult';
import PrintService from './PrintService';
import { diContainer } from '../DIContainer';
export class Printable {
    static HtmlRenderer = null;
    printableContent;
    renderSettings;
    constructor() {
        this.printableContent = [];
        this.renderSettings = {
            component: null,
            props: {},
        };
    }
    getRenderSettings() {
        return this.renderSettings;
    }
    setRenderSettings(settings) {
        this.renderSettings = settings;
    }
    l(type = 'L', content = '', contentOrOptions, options) {
        let opts = (typeof contentOrOptions === 'string' ? options : contentOrOptions) || {};
        let cont = ['' + content, typeof contentOrOptions === 'string' ? contentOrOptions : ''];
        this.printableContent.push({
            type,
            data: [
                { content: cont, ...opts }
            ],
        });
    }
    tl(...args) {
        const tableData = this.printableContent[this.printableContent.length - 1];
        if (tableData.type !== 'T')
            return;
        const updatedArgs = args.map(arg => {
            if (!Array.isArray(arg.content)) {
                arg.content = (arg.content !== '' && arg.content !== null && arg.content !== undefined)
                    ? [arg.content]
                    : [];
            }
            arg.content = arg.content.map(c => '' + c);
            return arg;
        });
        tableData.data = [...tableData.data, ...updatedArgs];
    }
    table(options) {
        const { colNumber = 2, text = {}, html = {} } = options;
        this.printableContent.push({
            type: 'T',
            data: [],
            colNumber,
            text,
            html,
        });
    }
    addPrintableContent(printableContent) {
        printableContent.map(pc => {
            pc.data = pc.data.map(d => {
                d.content = Array.isArray(d.content) ? d.content.map(c => '' + c) : d.content;
                return d;
            });
            return pc;
        });
        this.printableContent = [...this.printableContent, ...printableContent];
    }
    getIPrintableContent() {
        return this.printableContent;
    }
    async toText(options = {}) {
        const { charsPerLine = 32 } = options;
        const printableText = new PrintableText(this.printableContent, charsPerLine);
        return printableText.process();
    }
    async toHtml(options = {}) {
        const htmlGen = diContainer.resolve('htmlGen');
        const { wrapperClass, forceLightTheme = false, useComponent = true } = options;
        const { component = null, props = {} } = this.renderSettings;
        if (component && htmlGen && useComponent) {
            const html = await htmlGen.getHtml(component, {
                ...props,
                printable: this
            });
            return new PrintableResult([html], true, [{ width: 'normal', height: 'normal', bold: false }]);
        }
        const printableHtml = new PrintableHtml(this.printableContent, forceLightTheme, wrapperClass);
        return printableHtml.process();
    }
    print(options = {}) {
        return PrintService.print(this, options);
    }
}
export default Printable;
//# sourceMappingURL=Printable.js.map